import { push } from 'connected-react-router';
import * as ActionTypes from '../actions/types';
import AuthUtils from '../utils/AuthUtils';

const logoutRedirect = (store) => (next) => (action) => {
  if (action.type === ActionTypes.LOGOUT_SUCCESS) {
    AuthUtils.destroyToken();
    store.dispatch(push('/'));
  }
  return next(action);
};

export default logoutRedirect;
